import { structuredPatch, StructuredPatch, StructuredPatchHunk } from 'diff';

export interface DetectionDiff {
  patch: StructuredPatch;
  hunks: Array<{
    id: string;
    hunk: StructuredPatchHunk;
    type: 'add' | 'remove' | 'modify';
  }>;
}

/**
 * Generate structured diff between old and new detection body
 */
export function generateDetectionDiff(oldBody: string, newBody: string): DetectionDiff | null {
  if (!oldBody || !newBody) {
    return null;
  }

  // Normalize trailing whitespace to avoid false diffs from trailing newlines
  // that the LLM adds or removes without semantic meaning.
  const normalizedOld = oldBody.trimEnd();
  const normalizedNew = newBody.trimEnd();

  if (normalizedOld === normalizedNew) {
    return null;
  }

  const patch = structuredPatch(
    'detection.py',
    'detection.py',
    normalizedOld,
    normalizedNew,
    '',
    '',
    {
      context: 1,
    },
  );

  if (patch.hunks.length === 0) {
    return null;
  }

  const hunks = patch.hunks.map((hunk, index) => {
    // Determine change type based on hunk content
    const hasRemovals = hunk.lines.some(line => line.startsWith('-'));
    const hasAdditions = hunk.lines.some(line => line.startsWith('+'));

    let type: 'add' | 'remove' | 'modify';
    if (hasRemovals && hasAdditions) {
      type = 'modify';
    } else if (hasAdditions) {
      type = 'add';
    } else {
      type = 'remove';
    }

    return {
      id: `hunk_${index}_${hunk.oldStart}_${hunk.newStart}`,
      hunk,
      type,
    };
  });

  return { patch, hunks };
}
